import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../../../../utils/apiConfig';

const DEFAULT_MAX_COUNT = 3;

const parseMaxCount = (value) => {
  const parsed = Number.parseInt(String(value ?? '').trim(), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_MAX_COUNT;
};

export default function useEcPromoBannerSettings() {
  const [maxCount, setMaxCount] = useState(DEFAULT_MAX_COUNT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadSettings = async () => {
      try {
        const response = await axios.get(`${getApiBaseUrl()}/clientsettings/getall`);
        const settings = response.data?.data?.[0] || response.data?.data || [];
        const setting = Array.isArray(settings)
          ? settings.find(
              (row) =>
                String(row.SettingType || '').trim() === 'ECStore'
                && String(row.SettingParameter || '').trim() === 'PromoBannerMaxCount',
            )
          : null;

        if (!cancelled) {
          setMaxCount(parseMaxCount(setting?.Value));
        }
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setMaxCount(DEFAULT_MAX_COUNT);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadSettings();

    return () => {
      cancelled = true;
    };
  }, []);

  return { maxCount, loading };
}
